/* Nivia mini cart toast
   - Intercepts /cart/add success and shows a small anchored toast
   - Bumps cart-icon badge
   - Hijacks header cart-icon click → opens the existing big halo sidebar drawer
   - Auto-dismisses after a delay; pauses on hover */
(function(){
  'use strict';
  var FREE_SHIP_THRESHOLD_CENTS = 8500; // $85 AUD per announcement bar
  var DISMISS_MS = 4500;
  var cur = window.Shopify && window.Shopify.currency || {active:'AUD'};
  var formatMoney = function(cents){
    if(window.Shopify && window.Shopify.formatMoney){
      try{return window.Shopify.formatMoney(cents,window.shop_money_format||'${{amount}}');}catch(e){}
    }
    return '$'+(cents/100).toFixed(2);
  };

  var toast,timer,lastFocus;

  function ensureToast(){
    if(toast) return toast;
    toast=document.createElement('div');
    toast.className='nk-toast';
    toast.setAttribute('role','status');
    toast.setAttribute('aria-live','polite');
    toast.innerHTML=[
      '<div class="nk-toast__head">',
        '<span class="nk-toast__check" aria-hidden="true">✓</span>',
        '<span class="nk-toast__head-text">Added to bag</span>',
        '<span class="nk-toast__count" data-nk-count></span>',
        '<button type="button" class="nk-toast__close" aria-label="Close">×</button>',
      '</div>',
      '<div class="nk-toast__body">',
        '<div class="nk-toast__media"><img alt="" loading="lazy" /></div>',
        '<div class="nk-toast__info">',
          '<p class="nk-toast__title"></p>',
          '<div class="nk-toast__variant"></div>',
          '<div class="nk-toast__price"></div>',
        '</div>',
      '</div>',
      '<div class="nk-toast__totalrow">',
        '<span class="nk-toast__totalrow-label">Bag total</span>',
        '<span class="nk-toast__totalrow-value" data-nk-total></span>',
      '</div>',
      '<div class="nk-toast__progress" hidden>',
        '<span class="nk-toast__progress-text"></span>',
        '<div class="nk-toast__progress-track"><div class="nk-toast__progress-fill"></div></div>',
      '</div>',
      '<div class="nk-toast__actions">',
        '<a class="nk-toast__btn nk-toast__btn--secondary" data-nk-view-bag href="/cart">View bag</a>',
        '<a class="nk-toast__btn nk-toast__btn--primary" href="/checkout">Checkout</a>',
      '</div>'
    ].join('');
    document.body.appendChild(toast);
    toast.addEventListener('click',function(e){
      if(e.target.closest('.nk-toast__close')){hide();}
      var view=e.target.closest('[data-nk-view-bag]');
      if(view){e.preventDefault();hide();openSidebar();}
    });
    toast.addEventListener('mouseenter',pause);
    toast.addEventListener('mouseleave',resume);
    return toast;
  }

  function anchorToCartIcon(){
    if(!toast)return;
    // find the FIRST visible cart-icon (themes render multiple for sticky/mobile)
    var icons=document.querySelectorAll('.header__icon--cart, a[href="/cart"].cart-icon-bubble, .cart-icon-bubble');
    var visible=null;
    for(var i=0;i<icons.length;i++){
      var r=icons[i].getBoundingClientRect();
      if(r.width>0 && r.height>0 && r.bottom>0 && r.bottom<window.innerHeight){visible=icons[i];break;}
    }
    if(visible){
      var rect=visible.getBoundingClientRect();
      toast.style.setProperty('--nk-toast-anchor-y',Math.max(rect.bottom,40)+'px');
    }else{
      // sensible default: under typical header height
      var hdr=document.querySelector('.shopify-section-group-header-group, .nivia-stitch-header, header[role="banner"], .header-wrapper');
      var hh=hdr?hdr.getBoundingClientRect().bottom:72;
      toast.style.setProperty('--nk-toast-anchor-y',Math.max(hh,40)+'px');
    }
  }

  function bumpBadge(){
    var bubbles=document.querySelectorAll('[data-cart-count], .cart-count-bubble, #cart-icon-bubble');
    bubbles.forEach(function(b){
      b.classList.remove('nk-cart-bump');
      // force reflow to restart animation
      // eslint-disable-next-line no-unused-expressions
      void b.offsetWidth;
      b.classList.add('nk-cart-bump');
    });
  }

  function updateBadgeCount(n){
    var bubbles=document.querySelectorAll('[data-cart-count]');
    bubbles.forEach(function(b){b.textContent=n;});
    var bubbleWraps=document.querySelectorAll('.cart-count-bubble');
    bubbleWraps.forEach(function(w){
      if(n>0){w.removeAttribute('hidden');w.style.display='';}
    });
  }

  function show(cart, addedItem){
    var t=ensureToast();
    var img=t.querySelector('.nk-toast__media img');
    var title=t.querySelector('.nk-toast__title');
    var variant=t.querySelector('.nk-toast__variant');
    var price=t.querySelector('.nk-toast__price');
    var progress=t.querySelector('.nk-toast__progress');
    var pText=t.querySelector('.nk-toast__progress-text');
    var pFill=t.querySelector('.nk-toast__progress-fill');

    // Bag count + total
    var countEl=t.querySelector('[data-nk-count]');
    var totalEl=t.querySelector('[data-nk-total]');
    if(countEl){countEl.textContent=(cart.item_count||0)+' '+((cart.item_count===1)?'item':'items');}
    if(totalEl){totalEl.textContent=formatMoney(cart.total_price||0);}

    var item=addedItem || (cart.items && cart.items[cart.items.length-1]) || null;
    if(item){
      var src=item.image||item.featured_image||(item.featured_image&&item.featured_image.url)||'';
      if(typeof src==='object'&&src&&src.url)src=src.url;
      if(src){
        // request a 120px Shopify CDN size
        if(src.indexOf('cdn.shopify.com')>-1||src.indexOf('shopifycdn')>-1){
          src=src.replace(/(\.(jpg|jpeg|png|webp|gif))(\?|$)/,'_120x120.$2$3');
        }
        img.src=src;img.alt=item.product_title||item.title||'';
      }
      title.textContent=item.product_title||item.title||'';
      var v=(item.variant_title&&item.variant_title!=='Default Title')?item.variant_title:'';
      variant.textContent=v;variant.style.display=v?'':'none';
      price.textContent=formatMoney(item.final_line_price||item.line_price||item.price||0);
    }

    // free-ship progress
    if(FREE_SHIP_THRESHOLD_CENTS>0){
      var total=cart.total_price||0;
      progress.hidden=false;
      if(total>=FREE_SHIP_THRESHOLD_CENTS){
        pText.textContent='You’ve unlocked free shipping 🎉';
        pFill.style.transform='translateX(0)';
        progress.classList.add('is-met');
      }else{
        var remain=FREE_SHIP_THRESHOLD_CENTS-total;
        pText.textContent=formatMoney(remain)+' away from free shipping';
        var pct=Math.max(4,Math.min(100,(total/FREE_SHIP_THRESHOLD_CENTS)*100));
        pFill.style.transform='translateX(-'+(100-pct)+'%)';
        progress.classList.remove('is-met');
      }
    }else{
      progress.hidden=true;
    }

    anchorToCartIcon();
    requestAnimationFrame(function(){t.classList.add('is-open');});
    bumpBadge();
    if(cart && typeof cart.item_count==='number')updateBadgeCount(cart.item_count);
    armTimer();
  }

  function hide(){
    if(!toast)return;
    toast.classList.remove('is-open');
    clearTimeout(timer);
  }
  function armTimer(){clearTimeout(timer);timer=setTimeout(hide,DISMISS_MS);}
  function pause(){clearTimeout(timer);}
  function resume(){armTimer();}

  function openSidebar(){
    if(document.querySelector('.halo-cart-sidebar')){
      try{
        if(window.Shopify && window.halo && window.halo.updateSidebarCart){
          window.Shopify.getCart(function(c){window.halo.updateSidebarCart(c);});
        }
      }catch(e){}
      document.body.classList.add('cart-sidebar-show');
    }else{
      window.location='/cart';
    }
  }

  /* ---- intercept /cart/add success ---- */

  // 1) fetch
  var origFetch=window.fetch;
  if(origFetch){
    window.fetch=function(input,init){
      var url=typeof input==='string'?input:(input&&input.url)||'';
      var isAdd=/\/cart\/add(\.js)?(\?|$)/.test(url);
      var p=origFetch.apply(this,arguments);
      if(isAdd){
        p.then(function(res){
          if(!res||!res.ok)return;
          // Don't consume the body — clone it
          res.clone().json().then(function(added){
            window.Shopify.getCart(function(cart){
              show(cart,addedToItem(added,cart));
            });
          }).catch(function(){
            window.Shopify.getCart(function(cart){show(cart,null);});
          });
        }).catch(function(){});
      }
      return p;
    };
  }

  // 2) jQuery ajax (theme uses $.ajax for some flows)
  if(window.jQuery){
    window.jQuery(document).ajaxComplete(function(_,xhr,settings){
      if(!settings || !settings.url)return;
      if(/\/cart\/add(\.js)?(\?|$)/.test(settings.url) && xhr.status>=200 && xhr.status<300){
        var added=null;
        try{added=typeof xhr.responseJSON==='object'?xhr.responseJSON:JSON.parse(xhr.responseText);}catch(e){}
        window.Shopify.getCart(function(cart){show(cart,addedToItem(added,cart));});
      }
    });
  }

  function addedToItem(added,cart){
    if(!added)return null;
    // If the response is a single line item, it has variant_id
    if(added.variant_id && cart && cart.items){
      var match=cart.items.filter(function(i){return i.variant_id===added.variant_id;});
      if(match.length)return match[match.length-1];
    }
    if(added.items && added.items.length){
      var last=added.items[added.items.length-1];
      if(cart && cart.items){
        var m=cart.items.filter(function(i){return i.variant_id===last.variant_id;});
        if(m.length)return m[m.length-1];
      }
      return last;
    }
    return added;
  }

  /* hijack cart-icon click → open sidebar drawer */
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href$="/cart"], a[href*="/cart?"], .header__icon--cart, .cart-icon-bubble');
    if(!a)return;
    // allow modifier-clicks to navigate normally
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.button===1)return;
    if(a.closest('.nk-toast'))return;
    if(!document.querySelector('.halo-cart-sidebar'))return;
    e.preventDefault();
    openSidebar();
  },true);

  // expose for theme.js patches if needed
  window.nkCartToast={show:show,hide:hide,openSidebar:openSidebar};
})();
